<script setup>
import {ref, onMounted} from 'vue'
import {useStore} from 'vuex'
import {useRoute} from 'vue-router';
import {UserApi} from "@/api/user";
import {ProjectApi} from "@/api/projects";
import {notify} from "@kyvg/vue3-notification";
import {getCurrentInstance} from 'vue'

const instance = getCurrentInstance()
const {$pluralise} = instance.appContext.config.globalProperties

const store = useStore()


const projects = ref([]);

onMounted(() => {
  ProjectApi.projects().then(response => projects.value = response)
})
const stateCreate = ref(false)
const project = {
  name: "",
}


function createProject(e) {
  e.preventDefault();
  ProjectApi.create_project(project).then(
      response => {
        projects.value.push(response)
        stateCreate.value = false
      }
  ).catch(e => notify({
    type: 'error',
    title: "Ошибка!",
    text: e.response.data.error,
  }))
}

function setActiveProject(project) {
  store.dispatch("setProjectId", project.id)
  if (project.resources) location.pathname = project.company_type?'/':'/dashboard';
  else location.pathname = "/settings";
}

function getShortName(project_name) {
  if (project_name) return project_name.split(' ').map(x => x[0]).join('').slice(0, 2).toUpperCase()
  return "-"
}


</script>

<template>

  <div class="back">
    <div class="projects-area">
      <router-link to="/" title="На главную" class="close">
        <i class="bi bi-x-lg"></i>
      </router-link>
      <div class="header">
        <h5>Выберите организацию</h5>
        <p class="help-text">Выберите рабочее пространство для продолжения</p>
      </div>
      <form @submit="createProject" v-if="stateCreate">
        <h4>Добавить новую организацию</h4>
        <div class="form-floating">
          <input class="form-control" required v-model="project.name" placeholder="Введите название проекта">
          <label>Название проекта</label>
        </div>
        <div class="buttons">
          <button class="btn btn-sm btn-primary">Добавить</button>
          <button class="btn btn-sm btn-secondary" @click="stateCreate=false">Отмена</button>
        </div>
      </form>
      <ul class="projects" v-else>
        <li v-for="project in projects" class="project" @click.prevent="setActiveProject(project)">
          <div class="ico" :style="{background: project.color}">{{ getShortName(project.name) }}</div>
          <div class="name">
            <div class="base-name">{{ project.name }}</div>
            <div class="help-text">{{ $pluralise(project.resources, ['площадка', 'площадки', 'площадок']) }}<i
                class="bi bi-circle-fill"></i>{{ $pluralise(project.reviews, ['отзыв', 'отзыва', 'отзывов']) }}
            </div>
            <span v-if="!project.active" class="status">Не активен</span>
          </div>
        </li>
        <li class="project new" v-if="$store.getters.tariff.max_project && projects.length<$store.getters.tariff.max_project" @click="stateCreate = true">
          <div class="ico">+</div>
          <div class="name">
            <div class="base-name"> Создать организацию</div>
            <div class="help-text">Добавить новое рабочее пространство</div>
          </div>
        </li>
      </ul>


    </div>

  </div>

</template>

<style scoped lang="scss">
.back {
  z-index: 1000;
  background: rgba(0, 0, 0, 0.3);
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  backdrop-filter: blur(10px);
  height: 100vh;

  .projects-area {
    position: relative;
    margin: 0 auto;
    background: var(--white);
    padding: 20px;
    border-radius: 10px;
    max-width: 1024px;
    margin-top: 50px;
    max-height: 88vh;
    overflow: auto;

    .close {
      position: absolute;
      right: 20px;
      top: 20px;
      cursor: pointer;

      &:hover {
        opacity: 0.9;
      }
    }

    form {
      padding: 20px;
      border-radius: 5px;
      border: 1px solid #ccc;
      display: flex;
      flex-direction: column;
      gap: 20px;

      .buttons {
        gap: 20px;
        display: flex;
      }
    }

    .header {
      h5 {
        font-weight: bold;
      }

      .help-text {
        color: var(--grey);
        font-size: 14px;
      }
    }

    .projects {
      display: flex;
      list-style-type: none;
      margin: 10px 0;
      padding: 0;
      flex-direction: column;
      gap: 15px;

      .project {
        box-shadow: var(--shadow);
        border-radius: 5px;
        cursor: pointer;
        display: flex;
        gap: 20px;
        padding: 15px;
        align-items: center;
        position: relative;

        &.new {
          background: var(--soft-blue);
          border: 2px dashed var(--light-blue);

          &:hover {
            opacity: 0.8;
          }

          i {
            display: none;
          }

          .ico {
            background: var(--white);
            font-size: 35px;
            font-weight: lighter;
            color: var(--primary);
          }
        }

         .status {
        position: absolute;
        top: -8px;
        font-size: 10px;
        background: red;
        border-radius: 5px;
        left: 6px;
        padding: 0 5px;
           color: #fff;
      }

        i {
          margin-left: auto;
        }

        .ico {
          height: 40px;
          width: 40px;
          font-size: 16px;
          font-weight: bold;
          color: var(--white);
          border-radius: 5px;
          background: var(--primary);
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .name {
          .base-name {
            font-weight: bold;
            font-size: 14px;
          }

          .help-text {
            font-size: 12px;
            color: var(--grey);
            display: flex;
            align-items: center;
            gap: 5px;
            justify-content: start;
            max-width: fit-content;

            i {
              font-size: 3px;
              flex: 1 1 auto;
            }
          }
        }

      }
    }
  }
}
</style>
